import { render, staticRenderFns } from "./CardsAmount.vue?vue&type=template&id=7ad7679e&scoped=true"
import script from "./CardsAmount.vue?vue&type=script&lang=js"
export * from "./CardsAmount.vue?vue&type=script&lang=js"
import style0 from "./CardsAmount.vue?vue&type=style&index=0&id=7ad7679e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad7679e",
  null
  
)

export default component.exports